﻿export default class AskQuestionButton {
    constructor() {
        this.id = 'askQuestionButton';
    }

    getHtml() {
        const styles = 'class="btn btn--yellow btn--width-100 btn--48-lg loading"';
        return `<button data-qa="ask-question-button" id="${this.id}" ${styles}>Ask Question</button>`;
    }

    getNode() {
        return document.getElementById(this.id);
    }
}
